import React, {useEffect, useState} from 'react';
import {getFilterPalletStatus} from "../../../microComponents/tablePages/getFilterPalletStatus";
import FilterSelectOption from "../../../microComponents/tablePages/filter/FilterSelectOption";

const FilterPalletStatus = () => {
    const [filterPalletStatus, setFilterPalletStatus] = useState([]);
    const [palletStatusLoading, setPalletStatusLoading] = useState(false);

    useEffect(() => {
        getFilterPalletStatus(setFilterPalletStatus, setPalletStatusLoading)

    }, []);
    return (

        <FilterSelectOption data={{
            filterName: 'palletStatus', loading: palletStatusLoading, placeholder: 'وضعیت', options: filterPalletStatus
        }}/>
    );
};

export default FilterPalletStatus;